var map = {
	"./Home": [
		2882,
		882
	],
	"./Home/": [
		2882,
		882
	],
	"./Home/index": [
		2882,
		882
	],
	"./Home/index.tsx": [
		2882,
		882
	],
	"./Policy": [
		5932,
		932
	],
	"./Policy/": [
		5932,
		932
	],
	"./Policy/index": [
		5932,
		932
	],
	"./Policy/index.tsx": [
		5932,
		932
	],
	"./Policy/styles": [
		8112,
		112
	],
	"./Policy/styles.ts": [
		8112,
		112
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;